<!-- eslint-disable vue/no-v-html -->

<template>
  <div class="pc-side-menu">
    <div
      v-if="isOpen"
      class="pc-side-menu__settings-PC__background"
      @click.self="onClose"
    >
      <div class="pc-side-menu__settings-PC">
        <div class="pc-side-menu__close-button__container">
          <div class="pc-side-menu__close-button" @click="onClose"></div>
        </div>

        <!-- <div v-if="menuKeyCard" class="pc-side-menu__card-menu">
          <div class="pc-side-menu__settings-header">カード</div>
          <point-card-registration-splash
            v-if="!isPointCardRegistered"
            :card-name="pointCardName"
            :help-link="pointCardHelpLink"
            :bg-image="null"
            class="pc-side-menu__settings-point-card"
          />
          <template v-if="isPointCardRegistered">
            <point-card-status
              :card-image="pointCardImage"
              :date="lastUpdatedDate"
              :point="point"
              :point-name="pointName"
              :expired-point="expiredPoint"
              :show-expired-point="canShowExpiredPoint"
              :expiration-date="expirationDate"
              :purchase-price-current-month="purchasePriceCurrentMonth"
              :purchase-price-last-month="purchasePriceLastMonth"
              :rank-reward="rankReward"
              :rank-highest="isRankHighest"
              :next-rank-reward="nextRankReward"
              :remaining-required-purchase-price-for-next-rank="
                remainingRequiredPurchasePriceForNextRank
              "
            />
            <p
              v-if="hasNote"
              class="pc-side-menu__note"
              v-html="unescapedText(pointCardNote)"
            ></p>
            <div class="pc-side-menu__app-number">
              <app-number :number="appNumber" />
            </div>
          </template>
        </div> -->

        <div
          class="pc-side-menu__settings-menu"
        >
          <!-- <div v-if="!isFlyerView" class="pc-side-menu__settings-header">
            設定
          </div>
          <point-card-menu
            v-if="!isFlyerView"
            class="pc-side-menu__point-card-menu"
            :items="pointCardMenuItems"
            :disabled="!isPointCardRegistered || !menuKeyCard"
            :disabled-items="[0, 2]"
          ></point-card-menu> -->
          <div
            class="menu__other"
            :class="{ 'menu__viewer-other': isFlyerView }"
          >
            <list-menu :items="listMenuItems" @item-click="onClose"/>
          </div>
        </div>
        <a :href="companyUrl" target="_blank" class="pc-side-menu__site-link"
          >{{ companyName }}へ</a
        >
      </div>
    </div>
  </div>
</template>

<script setup>
// import PointCardMenu from '@/components/PointCardMenu'
import ListMenu from '@/components/ListMenu'
import { useStore } from '@/stores/index'
import { useRoute } from 'vue-router'

const route = useRoute()
const runtimeConfig = useRuntimeConfig()

const data = await import(`@/data/${runtimeConfig.public.chainKey}/common/data.js`)

const rootStore = useStore()

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  utmSource: {
    type: [Number, String, null],
    default: null,
  },
})

const emit = defineEmits(['close'])

const companyName = ref(data.default.companyName)
const companyUrl = ref(data.default.companyUrl)

const isFlyerView = computed(() => {
  return true
})

const listMenuItems = computed(() => {
  return hasCookiePolicy.value ? [
      {
        text: 'よくあるご質問',
        link: props.utmSource
          ? `/faq?utm_source=${props.utmSource}`
          : '/faq/',
        routing: true,
        isPdf: false,
      },
      {
        text: 'プライバシーポリシー',
        link: props.utmSource
          ? `/privacy-policy?utm_source=${props.utmSource}`
          : '/privacy-policy/',
        routing: true,
        isPdf: false,
      },
      {
        text: '外部サービスの利用',
        link:
        runtimeConfig.public.staticBaseUrl +
          `assets/pdf/${runtimeConfig.public.chainKey}_transmission.pdf?` +
          Math.random().toString(36).slice(-10),
        routing: false,
        isPdf: true,
      },
    ]
  : [
      {
        text: 'よくあるご質問',
        link: props.utmSource
          ? `/faq?utm_source=${props.utmSource}`
          : '/faq/',
        routing: true,
        isPdf: false,
      },
      {
        text: 'プライバシーポリシー',
        link: props.utmSource
          ? `/privacy-policy?utm_source=${props.utmSource}`
          : '/privacy-policy/',
        routing: true,
        isPdf: false,
      },
    ]
})

const hasCookiePolicy = computed(() => {
  return runtimeConfig.public.hasCookiePolicy
})

watch(() => route, (to, from) => {
  onClose()
})

watch(() => props.isOpen, (newValue, oldValue) => {
  if (newValue) {
    document.body.style.overflow = 'hidden'
    document.addEventListener('touchmove', touchmoveFunction, {
      passive: false,
    })
  } else {
    document.body.removeAttribute('style')
    document.removeEventListener('touchmove', touchmoveFunction, {
      passive: false,
    })
  }
})

const onClose = () => {
  emit('close')
}

const openCancelDialog = () => {
  setMessageDialogs({ name: 'cancel', shown: true })
}

const closeCancelDialog = () => {
  setMessageDialogs({ name: 'cancel', shown: false })
}

const handleCancelRegistration = () => {
  cancelRegistration()
  closeCancelDialog()
}

const closeCompletionDialog = () => {
  setMessageDialogs({ name: 'completion', shown: false })
  window.setTimeout(() => {
    location.reload()
  }, 300)
}

const unescapedText = (text) => {
  return text
    .replace(/\\n/g, '<br />')
    .replace('アプリ内ポイント', 'ポイント特典')
}

const touchmoveFunction = (e) => {
  const menu = document.querySelector('.pc-side-menu__settings-PC')
  const scrollable = menu.scrollHeight > window.innerHeight
  if (menu.contains(e.target) && scrollable) {
    e.stopPropagation()
  } else {
    e.preventDefault()
  }
}
</script>

<style lang="scss" scoped>
.pc-side-menu {
  display: none;

  @media screen and (min-width: $tablet-breakpoint) {
    display: block;
    padding-left: 2rem;
    position: relative;
    top: 0;
    z-index: 101;
  }

  .pc-side-menu__app-number {
    padding: 1.6rem 0;
    border-top: 0.1rem solid $color-line;
  }
  .pc-side-menu__close-button {
    width: 2.4rem;
    height: 2.4rem;
    cursor: pointer;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      height: 3.3rem;
      width: 0.2rem;
      background: $color-main-text;
      transform: rotate(45deg);
      top: -0.4rem;
      right: 1.2rem;
    }
    &::before {
      content: '';
      position: absolute;
      height: 3.3rem;
      width: 0.2rem;
      background: $color-main-text;
      transform: rotate(-45deg);
      top: -0.4rem;
      right: 1.2rem;
    }
  }
  .pc-side-menu__close-button__container {
    width: 3.8rem;
    display: flex;
    justify-content: center;
    margin-left: auto;
    margin-right: 0;
  }
  .pc-side-menu__hamburger__container {
    width: 3.8rem;
    height: 2.4rem;
    cursor: pointer;
  }
  .pc-side-menu__note {
    margin: 1.6rem 0;
    color: $color-main-text;
    font-size: 1.4rem;
    line-height: calc(18 / 14);
    white-space: pre-line;
  }
  .pc-side-menu__point-card-menu {
    padding-bottom: 1.6rem;
  }

  .menu__viewer-other {
    padding-top: 4rem;
  }

  .pc-side-menu__settings-header {
    padding: 1.6rem 0 0.8rem;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: calc(23.17 / 16);
  }
  .pc-side-menu__settings-menu {
    padding: 0.8rem 0 0 0;
  }
  .pc-side-menu__card-menu {
    border-bottom: 0.05rem solid $color-line;
  }

  .pc-side-menu__settings-PC__background {
    background: #00000080;
    height: 100vh;
    width: 100vw;
    position: fixed;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
    top: 0;
    left: 0;
  }
  .pc-side-menu__settings-PC {
    background: $color-bg;
    width: 54rem;
    padding: 3.2rem 2.4rem;
    overflow-y: auto;
    @media screen and (min-width: $pc-breakpoint) {
      padding: 3.2rem 4rem;
    }
  }
  .pc-side-menu__settings-point-card {
    margin-bottom: 1.6rem;
  }

  .pc-side-menu__site-link {
    width: 100%;
    margin-top: 3.3rem;
    color: $color-main;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: calc(23.17 / 16);
    display: flex;
    justify-content: center;
    align-items: center;

    &::after {
      content: '';
      background-color: $color-main;
      mask: url('@/assets/images/icon-link-out.svg') no-repeat;
      background-size: contain;
      background-repeat: no-repeat;
      width: 1.6rem;
      height: 1.6rem;
      display: block;
      margin-left: 0.8rem;
    }
  }
}
</style>
